import React from 'react';
import Card from '../components/card';
import { LoanCard } from './card-lenses';

const LateTaxesCard = ({ ruleset, model, ...props }) => {
  return (
    <Card
      buttonType="none"
      title={"We don't have offers that fit your profile right now."}
      {...props}
    >
      <br />
      Lenders in our marketplace don’t service borrowers who filed late taxes without an extension
      in the past two years.
      <br />
      <br />
      After two years have elapsed since your late filing, you may be eligible for offers in our
      marketplace.
      <br />
      <br />
      If you have any questions, please send us a note at{' '}
      <a
        href="mailto:hello@ownup.com"
        className="link__hover--yellow"
        target="_blank"
        rel="noreferrer"
      >
        hello@ownup.com
      </a>
      .
    </Card>
  );
};

LateTaxesCard.id = 'LateTaxesCard';
LateTaxesCard.completed = () => false;

export const LateTaxes = LoanCard(LateTaxesCard);



// WEBPACK FOOTER //
// ./src/cards/late-taxes.js